import { cn } from "../../../../utils/global.utils";
import { profileEditList, type TProfileEditLink } from "../constants";
import { ActiveIcon, CompleteIcon, DefaultIcon } from "./EditHeaderIcon";

type EditHeaderProps = {
  isCompleted?: boolean;
  type: TProfileEditLink;
  onStepClick: (type: TProfileEditLink) => void;
};

export default function EditHeader({
  isCompleted,
  type,
  onStepClick,
}: EditHeaderProps) {
  return (
    <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-4 p-4 rounded-xl border border-theme-zinc-200">
      {profileEditList.map((el, idx) => (
        <div
          key={el.link}
          className={idx === 0 || idx === 3 ? "xl:col-span-2" : ""}
        >
          <button
            className={cn(
              "text-theme-slate-500 hover:text-theme-neutral-800 transition-colors text-sm font-bold flex items-center gap-3 text-left",
              (isCompleted || type === el.link) && "text-theme-neutral-800"
            )}
            onClick={() => onStepClick(el.link)}
          >
            {isCompleted ? (
              <CompleteIcon />
            ) : type === el.link ? (
              <ActiveIcon idx={idx} />
            ) : (
              <DefaultIcon />
            )}
            {el.title}
          </button>
        </div>
      ))}
    </div>
  );
}
